export default "__VITE_ASSET__Bk6EPRV0__"